import React from 'react';
import { Box, Typography } from '@mui/material';

const About = () => {
    return (
        <Box sx={{ padding: '25px', maxWidth: '850px', margin: '0 auto', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
            <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#2C3E50' }}>
                About SciCruit
            </Typography>

            <Typography variant="body1" paragraph sx={{ fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                SciCruit is revolutionizing sales recruitment by integrating AI-driven insights, adaptive assessments, and a structured hiring process. 
                Companies can now identify high-performing sales professionals with precision, while job seekers experience a transparent and engaging hiring journey.
            </Typography>

            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', marginTop: '25px', color: '#2C3E50' }}>
                The Challenges in Sales Recruiting
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                Hiring top sales talent is challenging. Candidates need strong communication, persuasion skills, industry expertise, and a proven ability to exceed quotas. 
                Traditional recruitment is slow, subjective, and often fails to identify the best candidates.
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                SciCruit streamlines hiring by automating screening and assessments, ensuring companies find the best fit faster, while job seekers showcase their real potential in an interactive process.
            </Typography>

            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', marginTop: '25px', color: '#2C3E50' }}>
                Key Industry Challenges
            </Typography>
            <ul style={{ textAlign: 'left', paddingLeft: '20px', fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                <li>Only 15% of new sales hires meet their quotas in their first year.</li>
                <li>Sales turnover exceeds 60%, leading to lost productivity and high hiring costs.</li>
                <li>It takes over six months to recruit and ramp up a new sales rep, causing revenue loss.</li>
                <li>Bad hiring decisions cost companies up to 200% of an employee’s annual salary.</li>
                <li>Over 60% of sales candidates find the hiring process lengthy, unclear, and biased.</li>
            </ul>

            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', marginTop: '25px', color: '#2C3E50' }}>
                The Minimum Requirements Rule
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                Any candidate who meets the minimum job requirements automatically advances through SciCruit’s AI-powered screening to the interview assessment stage.  
                Employers no longer need to manually sift through applications—SciCruit ensures that every qualified candidate gets a fair chance, increasing the talent pool and improving hiring efficiency.
            </Typography>

            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', marginTop: '25px', color: '#2C3E50' }}>
                How SciCruit Solves These Problems
            </Typography>
            <ul style={{ textAlign: 'left', paddingLeft: '20px', fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                <li><span style={{ color: '#2980B9', fontWeight: 'bold' }}>AI-Powered Adaptive Assessments:</span> SciCruit’s assessments use deep learning to align with specific industries and job roles. Candidates are evaluated on real-world sales scenarios, industry knowledge, adaptability, relationship-building, and cultural fit.</li>
                <li><span style={{ color: '#2980B9', fontWeight: 'bold' }}>Data-Driven Hiring Decisions:</span> Employers gain predictive insights and analytics to make faster and more precise hiring choices.</li>
                <li><span style={{ color: '#2980B9', fontWeight: 'bold' }}>Gamified Hiring Experience:</span> Candidates engage in interactive sales role-plays and simulations, making the process more engaging and accurate.</li>
                <li><span style={{ color: '#2980B9', fontWeight: 'bold' }}>Bias-Free Recruitment:</span> Hiring decisions are based solely on skills and performance, reducing biases and improving diversity in hiring.</li>
            </ul>

            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', marginTop: '25px', color: '#2C3E50' }}>
                A Better Experience for Candidates
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                SciCruit allows sales professionals to demonstrate their expertise in a fair, skills-based hiring process. 
                The platform eliminates repetitive job applications, ensuring each candidate receives a real evaluation of their abilities and the best possible job match.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ marginTop: '35px', fontWeight: 'bold', color: '#2C3E50' }}>
                A Smarter, Faster, and More Accurate Way to Hire and Get Hired
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                Whether you're an employer searching for top sales talent or a job seeker looking for the right role, 
                SciCruit delivers a structured, data-driven hiring process that benefits everyone.
            </Typography>
        </Box>
    );
};

export default About;

